import gql from 'graphql-tag';

export const tokenFragment = gql`
  fragment tokenFragment on Token {
    dokkioClass
    accountID
    dokkioUserID
    accessToken
    expiresInSeconds
    refreshToken
  }
`;
export default tokenFragment;
